import { TextareaField } from '#app/components/form/textarea-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly brandNames: string
	readonly errors: readonly string[]
	readonly onChange: (value: string) => void
}

export function BrandsSection({
	resources,
	brandNames,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Brands covered"
			description="List every brand or product family you want referenced in the SOP output."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<TextareaField
				labelProps={{
					children: 'Which brands and product lines should we cover?',
				}}
				textareaProps={{
					name: 'brandNames',
					value: brandNames,
					onChange: (event) => onChange(event.target.value),
					rows: 4,
				}}
				descriptionProps={{
					children:
						'Separate entries with commas or line breaks—for example, "Lydra Skin", "Lydra Hair".',
				}}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
